import React from 'react';
import { FieldTone, inputClass, labelClass } from '../../../utils/fieldStyles';
interface TextAreaFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  tone?: FieldTone;
}
export function TextAreaField({
  id,
  label,
  value,
  onChange,
  placeholder,
  tone = 'light'
}: TextAreaFieldProps) {
  return <div data-id="element-66" data-mp="2jmg68uoh6arq">
      <label htmlFor={id} className={labelClass(tone)} data-id="element-67" data-mp="3gejqvucohelo">
        {label}
      </label>
      <textarea id={id} name={id} rows={4} value={value} placeholder={placeholder} onChange={event => onChange(event.target.value)} className={`resize-y py-3 ${inputClass(tone, false)}`} data-id="element-68" data-mp="3gc7ctsa1jodw" />
    </div>;
}